var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "header container" },
    [
      _c(
        "router-link",
        {
          staticClass: "logo",
          class: {
            "b-sprite-landing-brilliant-logo-black": !_vm.mobile,
            "b-sprite-landing-brilliant-logo-black-small": _vm.mobile
          },
          attrs: { to: { name: "homepage" } }
        },
        [_vm._v("Brilliant")]
      ),
      _vm._v(" "),
      !_vm.isAuthenticated
        ? _c("LoginButton", {
            attrs: {
              "ax-type": "link",
              "ax-id": _vm.axParams.ids.headerLogInBtn,
              "ax-extra": _vm.axParams.extra
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.showHeader
          ? _c("div", { staticClass: "index-header" }, [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "logo",
                      class: {
                        "b-sprite-landing-brilliant-logo-black": !_vm.mobile,
                        "b-sprite-landing-brilliant-logo-black-small":
                          _vm.mobile
                      },
                      attrs: { to: { name: "homepage" } }
                    },
                    [_vm._v("\n          Brilliant\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "SignupButton",
                    {
                      attrs: {
                        variant: "green",
                        "is-mathcounts": _vm.isMathcounts,
                        "ax-id": _vm.axParams.ids.stickyHeaderSignUpBtn
                      }
                    },
                    [_vm._v("\n          Get started\n        ")]
                  ),
                  _vm._v(" "),
                  !_vm.isAuthenticated
                    ? _c("LoginButton", {
                        attrs: {
                          "ax-id": _vm.axParams.ids.stickyHeaderLogInBtn,
                          "ax-type": "button"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }